import styled from 'styled-components';

interface SwitchProps {
  checked: boolean;
  handleChange?: () => void;
}

const ToggleSwitch = ({ checked, handleChange }: SwitchProps) => {
  return (
    <Container checked={checked}>
      <input
        id="checkbox"
        type="checkbox"
        checked={checked}
        onChange={handleChange}
      />
    </Container>
  );
};

const Container = styled.label<{ checked: boolean }>`
  cursor: pointer;
  text-indent: -9999px;
  width: 44px;
  height: 25px;
  background: ${({ checked }) => (checked ? '#015c9a' : '#ccc')};
  display: block;
  border-radius: 100px;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    left: ${({ checked }) => (checked ? '3px' : '50%')};
    top: 3px;
    width: 20px;
    height: 20px;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
  }
`;
export default ToggleSwitch;
